import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { connect } from 'react-redux'
import Snackbar from 'material-ui/Snackbar'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import EasyTransition from 'react-easy-transition'
import MainMenu from './MainMenu'
import LeftSidebar from './LeftSidebar'
import EventShower from './EventShower'
import { isLoggedIn } from '../../utils/utils'
import { settings, hideAppFeedback } from '../../actions'
import './style.css'
import './mui.min.css'

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this)
    this.state = {
      sidebarOpen: false,
    }
  }

  componentDidMount() {
    if (isLoggedIn()) {
      this.props.settings()
    }
  }

  handleToggleSidebar = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen })
  }

  buildMuiTheme = () => getMuiTheme({
    fontFamily: 'Roboto, sans-serif',
    palette: {
      primary1Color: this.props.layout.primary_color,
      primary2Color: this.props.layout.primary_color,
      primary3Color: this.props.layout.primary_color,
      accent1Color: this.props.layout.element_color,
      accent2Color: this.props.layout.element_color,
      accent3Color: this.props.layout.element_color,
    },
  })

  current_son = () =>
    React.cloneElement(this.props.children, {
      key: this.props.location.pathname,
    })

  render() {
    const { hasBack } = this.props.routes[1]
    return (
      <MuiThemeProvider
        muiTheme={
        this.buildMuiTheme()}
      >
        <div>
          <MainMenu
            currentPath={this.props.location.pathname}
            hasBack={!!hasBack}
            loggedIn={isLoggedIn()}
            toggleSidebar={this.handleToggleSidebar}
          />
          {isLoggedIn() ?
            <LeftSidebar
              sidebarOpen={this.state.sidebarOpen}
              toggleSidebar={this.handleToggleSidebar}
            /> : null
          }
          <div key={0} style={{ paddingTop: '64px' }}>
            <EasyTransition
              path={this.props.location.pathname}
              initialStyle={{ opacity: 0 }}
              transition="opacity 0.25s ease-in"
              finalStyle={{ opacity: 1 }}
            >
              {this.current_son()}
            </EasyTransition>
          </div>
          <Snackbar
            open={this.props.user_feedback.open}
            message={this.props.user_feedback.message}
            action={this.props.user_feedback.action}
            autoHideDuration={this.props.user_feedback.autoHideDuration}
            onRequestClose={this.props.hideAppFeedback}
          />
          <EventShower />
        </div>
      </MuiThemeProvider>
    )
  }
}

Layout.propTypes = {
  children: React.PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  settings: React.PropTypes.func.isRequired,
  layout: React.PropTypes.shape({
    primary_color: React.PropTypes.string.isRequired,
    element_color: React.PropTypes.string.isRequired,
    element_text_color: React.PropTypes.string.isRequired,
  }).isRequired,
  user_feedback: React.PropTypes.shape({
    open: React.PropTypes.bool,
    message: React.PropTypes.string,
    action: React.PropTypes.string,
    autoHideDuration: React.PropTypes.number,
  }),
  hideAppFeedback: React.PropTypes.func,
  routes: React.PropTypes.arrayOf(React.PropTypes.shape({
    hasBack: React.PropTypes.bool,
  })),
  location: React.PropTypes.shape({
    pathname: React.PropTypes.string.isRequired,
  }),
}

const mapStateToProps = state => ({
  ...state,
  user_feedback: state.ui.user_feedback,
  layout: state.layout,
})

const mapDispatchToProps = dispatch => ({
  settings: () => dispatch(settings()),
  hideAppFeedback: () => dispatch(hideAppFeedback()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout)




// WEBPACK FOOTER //
// ./src/components/Layout/index.jsx